import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import SEO from "../seo";
import Header from "../Header/Header";
import HeaderMobile from "../Header/HeaderMobile";
import { PAGE_TYPES } from "../../utils/constants";

const ResponsiveFooter = dynamic(() => import("../ResponsiveFooter"));

const CustomerLogos = dynamic(() => import("../LandingPage/CustomerLogos"), {
	ssr: false,
});

const IntercomWrapper = dynamic(() => import("../../utils/Intercom"), {
	ssr: false,
});

const StatsBanner = dynamic(() => import("../StatsBanner/StatsBanner"));

const Layout = ({
	children,
	heading = undefined,
	hideHeading = false,
	title,
	description,
	image = undefined,
	source,
	hideStatsBanner,
	hideMainHeader = undefined,
	subHeading = undefined,
	headerIdDesktopView = undefined,
	headerIdMobileView = undefined,
	user = undefined,
	metaTitle,
	hideIntercom,
	headerBgColor,
	rightActionBar,
	hideCustomerLogosSection,
	ogUrl = undefined,
	headerColor,
	hideBrandLines,
	referrerId = undefined,
	cityDropdown = undefined,
	name = undefined,
	hideHeaderAll = undefined,
	backgroundColor = undefined,
	customUtmMedium = PAGE_TYPES.long,
	headerSeperator = undefined,
	slug,
	is404 = false,
	stickyHeader = false,
	hideHeaderTitleOnMobile = false,
	disableIndexing = false,
}) => (
	<>
		{!hideIntercom && <IntercomWrapper />}
		<SEO
			title={title}
			metaImage={image}
			description={description}
			metaTitle={metaTitle}
			image={image}
			ogUrl={ogUrl}
			slug={slug}
			is404={is404}
			disableIndexing={disableIndexing}
		/>
		{!hideHeaderAll && (
			<Header
				hideHeading={hideHeading}
				heading={heading}
				source={source}
				id={headerIdDesktopView}
				headerBgColor={headerBgColor}
				rightActionBar={rightActionBar}
				headerColor={headerColor}
				hideBrandLines={hideBrandLines}
				cityDropdown={cityDropdown}
				customUtmMedium={customUtmMedium}
				headerSeperator={headerSeperator}
				sticky={stickyHeader}
				hideHeaderTitleOnMobile={hideHeaderTitleOnMobile}
			/>
		)}
		{!hideMainHeader && (
			<HeaderMobile
				heading={heading}
				subHeading={subHeading}
				source={source}
				id={headerIdMobileView}
				user={user}
				referrerId={referrerId}
				name={name}
				customUtmMedium={customUtmMedium}
			/>
		)}
		<main style={backgroundColor ? { backgroundColor } : null}>{children}</main>
		{!hideCustomerLogosSection && <CustomerLogos />}
		{!hideStatsBanner && <StatsBanner />}
		<ResponsiveFooter customUtmMedium={customUtmMedium} source={source} />
	</>
);

Layout.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
};

export default Layout;
